export default __webpack_public_path__ + "media/images/theme/m_logo_light_backup-e98834935f07cff6ba255b007dbebf28.png";